import { render } from "./IncluirProdutos.vue?vue&type=template&id=88468ec6&scoped=true"
import script from "./IncluirProdutos.vue?vue&type=script&lang=js"
export * from "./IncluirProdutos.vue?vue&type=script&lang=js"

import "./IncluirProdutos.vue?vue&type=style&index=0&id=88468ec6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src130918171/src/app-heineken/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88468ec6"]])

export default __exports__